const selectorProductInfo = '.js-product-info',
    selectorStoreContainer = '.js-product-pickup-details';

module.exports = function () {
    const $body = $('body');
    const $cart = $('.js-cart');

    const changeStoreHelper = require('./changeStore');
    changeStoreHelper.init();

    $('.js-pickup-option').on('change', (e) => {
        const $target = $(e.target);
        const $cartItem = $target.closest(selectorProductInfo);
        const $storeContainer = $cartItem.find(selectorStoreContainer);

        if ($target.val() === 'homeDelivery') {
            $('body').trigger('homedelivery:selected', $cartItem);
            $target
                .parents('.js-shipping-form-group')
                .find('.js-selected-checkbox')
                .removeClass('js-selected-checkbox');
            $target.addClass('js-selected-checkbox');
        } else if ($target.val() === 'doorDash') {
            if ($target.hasClass('js-empty-inventory') && $storeContainer.closest('.js-product-detail').data('store-id') === '') {
                $cartItem.addClass('js-selected-product');
                $storeContainer.closest('.js-product-detail').addClass('js-door-dash-info');
                $('body').trigger('door:selected', { item: $cartItem, trigger: $target });
            } else {
                $storeContainer.closest('.js-product-detail').addClass('js-door-dash-info');
                $('body').trigger('doordash:selected', { item: $cartItem, trigger: $target });
            }
            $target.on('click', (e) => {
                var elem = $('#doorDashModal');
                if (elem.is(':visible') && !elem.is(e.target) && elem.has(e.target).length === 0) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                    $storeContainer.closest('.js-product-detail').removeClass('js-door-dash-info');
                    $target.off('click');
                }
            });

            $(document.body).on('click', '.js-close-confirm-select', () => {
                var elem = $('#doorDashModal');
                if (elem.is(':visible')) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                    $storeContainer.closest('.js-product-detail').removeClass('js-door-dash-info');
                }
            });

            $target.on('click', (e) => {
                var elem = $('#inStoreInventoryModal');
                if (elem.is(':visible') && !elem.is(e.target) && elem.has(e.target).length === 0) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                    $storeContainer.closest('.js-product-detail').removeClass('js-door-dash-info');
                    $target.off('click');
                }
            });

            $(document.body).on('click', '.js-close-confirm-select', () => {
                var elem = $('#inStoreInventoryModal');
                if (elem.is(':visible')) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                    $storeContainer.closest('.js-product-detail').removeClass('js-door-dash-info');
                }
            });

        } else {
            $('body').trigger('pickupinstore:selected', { item: $cartItem, trigger: $target });

            $target.on('click', (e) => {
                var elem = $('#inStoreInventoryModal');
                if (elem.is(':visible') && !elem.is(e.target) && elem.has(e.target).length === 0) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                    $target.off('click');
                }
            });

            $(document.body).on('click', '.js-close-confirm-select', () => {
                var elem = $('#inStoreInventoryModal');
                if (elem.is(':visible')) {
                    $target.closest('.js-shipping-form-group')
                        .find('.js-selected-checkbox')
                        .prop('checked', true);
                }
            });
        }
    });

    $('#shippingMethods').change(function () {
        const url = $(this).attr('data-actionUrl');
        const urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $cart.spinner().start();

        $.ajax({
            url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success(data) {
                if (data.error) {
                    window.window.location.href = data.redirectUrl;
                } else {
                    $('body')
                        .trigger('basket:update:totals', data)
                        .trigger('basket:update:discounts', { discounts: data.approachingDiscounts })
                        .trigger('basket:update:promos', data.totals.discountsHtml)
                        .trigger('basket:validate', data.basket);
                }
            },
            error(err) {
                if (err.redirectUrl) {
                    window.window.location.href = err.redirectUrl;
                } else {
                    $body.trigger('basket:notify', err.responseJSON.errorMessage);
                }
            }
        }).always(() => $cart.spinner().stop());
    });
};
